var map = {
	"./arrows.png": 84,
	"./atm.png": 85,
	"./book-distribution.png": 86,
	"./building.png": 87,
	"./bus-station.png": 88,
	"./campus.png": 89,
	"./clinic.png": 90,
	"./close-round.png": 91,
	"./close.png": 92,
	"./college.png": 93,
	"./computer.png": 94,
	"./crescent-building.png": 95,
	"./department.png": 96,
	"./dining.png": 97,
	"./faculty.png": 98,
	"./food-dining.png": 99,
	"./gate.png": 100,
	"./hall.png": 101,
	"./home.png": 102,
	"./hostel.png": 103,
	"./laboratory.png": 104,
	"./library.png": 105,
	"./location-marker.png": 106,
	"./location.png": 107,
	"./map.png": 30,
	"./marker.png": 108,
	"./masjid.png": 109,
	"./meeting-room.png": 110,
	"./menu.png": 111,
	"./mosque.png": 112,
	"./parking.png": 113,
	"./point.png": 114,
	"./post-office.png": 115,
	"./print.png": 116,
	"./reception.png": 117,
	"./residence.png": 118,
	"./restaurant.png": 119,
	"./room.png": 120,
	"./science-innovation-park.png": 121,
	"./search.png": 122,
	"./security.png": 123,
	"./shared.png": 124,
	"./sport-facility.png": 125,
	"./sport.png": 126,
	"./sports-complex.png": 127,
	"./stair.png": 128,
	"./store-rooms.png": 129,
	"./store.png": 130,
	"./student-village.png": 131,
	"./tick.png": 132,
	"./tick1.png": 133,
	"./uaeu-logo-white.png": 15,
	"./uaeu-logo.png": 31,
	"./wc.png": 134,
	"./wireless.png": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*\.png$
// module id = 14
// module chunks = 0